var watchlistPositionList = {
	caption: "Liste Position",
	name: "Nom",
	isin: "ISIN",
	lastPrice: "Dernier cours",
	lastPriceDateTime: "Date/Heure",
	perf: "Perf.",
	perfRel: "Perf. %",
	volume: "Volume",
	tradingVolume: "Trading Vol.",
	exchange: "Marché",
	actions: "Actions",
	noPositions: "Aucun résultat trouvé"
};
var fr = {
	watchlistPositionList: watchlistPositionList
};

export { fr as default, watchlistPositionList };
